// Create Use Case wizard endpoints (backend SPEC §9, request group
// Sensika\Api\v1_0\UseCase\*). Names follow {ROOT}_{VERB}_{REST}; the query
// string on template_schema is excluded from the constant name.

// * GET =====================================
export const USE_CASE_GET_TEMPLATES = `/use_case/templates`;

export const USE_CASE_GET_TEMPLATE_SCHEMA = `/use_case/template_schema`;

export const USE_CASE_GET = (objectId: string) => `/use_case/${objectId}`;

// * PATCH ===================================

// * POST ====================================
export const USE_CASE_POST_PREVIEW = `/use_case/preview`;

export const USE_CASE_POST_PROVISION = `/use_case/provision`;

// * DELETE ==================================
export const USE_CASE_DELETE = (objectId: string) => `/use_case/${objectId}`;

// * PUT =====================================
